import React, { useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { OverlayPanel } from 'primereact/overlaypanel'

type FieldInfoButtonProps = {
    ariaLabel: string
    text: string
    testId?: string
}

export const FieldInfoButton = ({ ariaLabel, text, testId = 'field-info-button' }: FieldInfoButtonProps) => {
    const overlayPanelRef = useRef<OverlayPanel>(null)
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <Button
                type="button"
                icon="pi pi-info-circle"
                unstyled
                className="inline-flex align-items-center justify-content-center p-0 border-none bg-transparent text-blue-500 cursor-pointer w-2rem h-2rem"
                aria-label={ariaLabel}
                aria-expanded={isOpen}
                data-testid={testId}
                pt={{
                    icon: {
                        className: 'text-xl',
                    },
                    label: {
                        className: 'hidden',
                    },
                }}
                onClick={(event) => {
                    setIsOpen((open) => !open)
                    overlayPanelRef.current?.toggle(event)
                }}
            />
            <OverlayPanel
                ref={overlayPanelRef}
                closeOnEscape
                className="max-w-20rem"
                data-testid={`${testId}-overlay`}
                onHide={() => setIsOpen(false)}
                onShow={() => setIsOpen(true)}
            >
                <span className="block px-3 py-2 line-height-3">{text}</span>
            </OverlayPanel>
        </>
    )
}
